import React from 'react'
import { Box } from '@mui/material'
import {
  contentColumnMaxWidthSx,
  contentColumnPageShellSx
} from '../../UI/contentColumn'

const MarketingPageLayout = ({ children }) => {
  return (
    <Box sx={contentColumnPageShellSx}>
      <Box sx={{ ...contentColumnMaxWidthSx, overflowX: 'hidden' }}>
        <Box
          sx={{
            bgcolor: '#0B0F19',
            minHeight: 'calc(100svh - 80px)',
            height: 'calc(100svh - 80px)',
            borderRadius: 2,
            p: 3,
            overflowX: 'hidden',
            overflowY: 'auto',
            width: '100%',
            boxSizing: 'border-box',
            maxWidth: '100%',
            color: '#E6E9EF',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  )
}

export default MarketingPageLayout


